export default "__VITE_ASSET__DSX7sDll__"